import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  preferences: {},
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isPending: true },
  };
}

function handleSuccess(
  state: State,
  preferences: Boundaries["retrievePreferences"]["success"],
): State {
  return {
    ...state,
    request: { ...initialState.request, isSuccessful: true },
    preferences,
  };
}

function handleFailure(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isFailure: true },
  };
}

function handleEdition(
  state: State,
  preferences: Boundaries["editPreferences"]["request"],
): State {
  return { ...state, preferences };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrievePreferencesRequested]: handleRequest,
    [events.retrievePreferencesSucceeded]: handleSuccess,
    [events.retrievePreferencesFailed]: handleFailure,
    [events.editPreferencesRequested]: handleEdition,
  }),
  [events.changePlanzoneSucceeded],
);

function createSelector(getState: () => State): Selector {
  return {
    getPreferences() {
      return getState().preferences;
    },
    isRetrievePreferencesRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrievePreferencesRequestPending() {
      return getState().request.isPending;
    },
    isRetrievePreferencesRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
